export const shareConfig = {
    title: '感谢您的热心捐助',
    link: '//donate.shmednew.com/#/',
    imgUrl: 'http://donate.shmednew.com/logo.jpeg',
    desc: '糖尿病干预救助专项基金感谢您对孩子们的帮助！关爱糖尿病儿童，关爱中国的未来！'
};


// WEBPACK FOOTER //
// ./src/config/index.js